import React from "react";
import styled from "styled-components";
import { number, bool } from "prop-types";
import { motion } from "framer-motion";

const Checker = styled.svg`
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 2;
  transform: translate(-50%, -50%);
`;

const CheckMark = ({
  width = 29,
  height = 25,
  isComplete,
  delay = 0.6,
  duration = 0.25,
}) => (
  <Checker
    width={width}
    height={height}
    viewBox="0 0 39 35"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <motion.path
      d="M12.5422 25.75L2 17.4167L12.5422 32L37 2L12.5422 25.75Z"
      fill="white"
      stroke="white"
      strokeWidth="3"
      initial={{ pathLength: 0, fill: "rgba(255,255,255,0)" }}
      animate={{
        pathLength: isComplete ? 1 : 0,
        fill: isComplete ? "rgba(255,255,255,1)" : "rgba(255,255,255,0)",
      }}
      transition={{ delay, duration }}
    />
  </Checker>
);

CheckMark.propTypes = {
  height: number,
  width: number,
  isComplete: bool,
  delay: number,
  duration: number,
};

export default CheckMark;
